// 项目接口
import { projectDetail } from "@/api/project";
import { investigate } from "@/api/investigate";
export default {
  namespaced: true, // 开启命名空间
  state: {
    rlProject_id: "", // 当前项目id --- 常用(与后端交互传参/indexedDB存储/页面跳转需要)
    rlProject_name: "", // 当前项目name  --- 界面展示需要
    rlProject_detail: {}, // *** 当前项目详情数据

    rlBuilding: {}, // 当前楼层 --- 常用(操作类里根据当前楼层信息拿到需要的数据/部分界面交互展示样式/检测模块)
    floorCopyData: [], // 局部复制的数据源 --- 仅用于复制存储临时数据,在新增楼层addFloor.vue页面使用,搜索options.copyType == 2可以查到使用的地方声明了一个一模一样的数据名?

    initEntity: null, // 建模初始值 --- 没用到 连写入的方法都没有

    layerinformationAll: [], // 层信息数据 --- 新增的字段及模块,检测要用到层信息

    tipCoord: "0.000,0.000,0.000", // 鼠标坐标 --- 变化速度比较快,建议增加节流函数节流,减少函数调用次数,减少cpu开销

    deleteEntityIDs: [], // 删除实体的id集合   --- 实体类的js文件有用到
    modelStrength: [], // 强度值   --- 强度模块新增需求,检测会用到

    rlFont: null, // 字体

    moveDistObj: {}, // 移动距离对象
    snapPoint: {}, // 捕捉点--通过鼠标移动监听计算
    forceRlGridSnap: false, // 是否强制对rlGrid进行端点捕捉
    // 背景颜色
    bgc: 200,
    lock: true, //锁住
    userList: [], //用户列表
    push_time: "", //最后时间
    isSaveLoading: false, //是否保存中
    isSaveTips: "",
    applicationList: [],
    applicationShowDialogVisible: false,
    crackSelectMb: [],
    isCrackSelectIng: false, // 是否多选裂损数据
    currentSelectCrack: null, //当前选中的裂损
    isGountitleOrthogonalActive: true,
    undergroundNumber: 0, //地下室层数
  },
  //  同步方法
  mutations: {
    setIsGountitleOrthogonalActive(state, val) {
      state.isGountitleOrthogonalActive = val;
    },
    // 添加裂损选中的id
    setCrackSelectMb(state, obj) {
      state.crackSelectMb = obj;
    },
    // 设置强制对rlGrid进行端点捕捉
    setForceRlGridSnap(state, obj) {
      state.forceRlGridSnap = obj;
    },
    // 设置移动距离对象
    setMoveDistObj(state, obj) {
      state.moveDistObj = obj;
    },
    // 设置命名的字体样式
    set_rlFont(state, font) {
      state.rlFont = font;
    },
    // rlProjectObj赋值
    set_rlProjectObj(state, obj) {
      const { project_id, project_name } = obj;
      state.rlProject_id = project_id;
      state.rlProject_name = project_name;
    },
    // 设置当前楼层ID
    set_rlBuilding(state, obj) {
      state.rlBuilding = obj;
      // store.commit('cadModules/draw_floor', obj)
    },
    // 设置鼠标位置
    set_tipCoord(state, obj) {
      state.tipCoord = obj;
    },
    // 强度设置
    setGlobalStrength(state, data) {
      state.modelStrength = data;
    },
    // 设置鼠标捕捉点
    setSnapPoint(state, obj) {
      state.snapPoint = obj;
    },
    // 设置项目详情数据
    set_rlProjectVal(state, obj) {
      state.rlProject_detail = obj;
    },
    // 设置背景颜色
    set_bgc(state, obj) {
      state.bgc = obj;
    },
    //设置地下室层数
    set_undergroundNumber(state, obj) {
      state.undergroundNumber = obj ?? 0;
    },
  },
  // 异步方法
  actions: {
    // 获取当前项目详情数据
    async getProjectVal(store, id) {
      try {
        const res = await projectDetail(id || store.state.rlProject_id);
        // console.log("res-set_rlProjectVal", res);
        store.commit("set_rlProjectVal", res.data);
        return res;
      } catch (error) {
        console.log("error", error);
      }
    },
    //获取地下室层数
    async getUndergroundNumber(store, id) {
      try {
        const res = await investigate({
          project_id: id || store.state.rlProject_id,
        });

        store.commit("set_undergroundNumber", res.data?.down_number);
        return res;
      } catch (error) {
        console.log("error", error);
      }
    },
  },
  getters: {},
};
